<template>
    <v-dialog v-model="dialog" :width="width" :max-width="maxWidth" v-if="request.isDone">
        <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="gray-9" v-on="on" v-bind="attrs">자문보고서</v-btn>
        </template>
        <counsel-report-card :request="request" />

        <v-btn @click="print" fixed right bottom fab elevation="24" id="print-button">
            <v-icon>mdi-printer</v-icon>
        </v-btn>
    </v-dialog>
</template>

<script>
import CounselReportCard from "./counsel-report-card.vue";
export default {
    components: { CounselReportCard },
    props: ["request"],
    data() {
        return {
            dialog: false,
            width: "1280px",
            maxWidth: "85%",
        };
    },
    methods: {
        print() {
            this.width = "100%";
            this.maxWidth = "100%";

            const targetElm = document.getElementById("print-target").parentElement;
            targetElm.style.height = "100%";
            targetElm.style.maxHeight = "100%";
            targetElm.style.height = "100%";
            targetElm.style.margin = "0";
            targetElm.style.overflowY = "hidden";

            const btnElm = document.getElementById("print-button");
            btnElm.style.display = "none";

            const appElm = targetElm.parentNode.previousSibling;
            appElm.style.display = "none";
            const scrnElm = appElm.previousSibling;
            scrnElm.style.opacity = "0";

            setTimeout(() => {
                window.print();
            }, 100);

            setTimeout(() => {
                this.width = "1280px";
                this.maxWidth = "85%";

                targetElm.style.height = null;
                targetElm.style.maxHeight = null;
                targetElm.style.height = null;
                targetElm.style.margin = null;
                targetElm.style.overflowY = null;

                btnElm.style.display = null;
                appElm.style.display = null;
                scrnElm.style.opacity = null;
            }, 300);
        },

        //         print() {
        //             const targetHtml = document.getElementById("print-target").outerHTML;
        //             const stylesHtml = [...document.querySelectorAll('link[rel="stylesheet"], style')].reduce((html, node) => html + node.outerHTML, "");

        //             const PrintWindow = window.open("", "PrintWindow", `left=0,top=0,width=1280,height=900,toolbar=0,scrollbars=0,status=0`);

        //             PrintWindow.document.write(`<!DOCTYPE html>
        // <html>
        //     <head>
        //         ${stylesHtml}
        //     </head>
        //     <body>
        //         ${targetHtml}
        //     </body>
        // </html>`);

        //             PrintWindow.document.close();
        //             PrintWindow.focus();
        //             // setTimeout(() => PrintWindow.print(), 500);
        //             // setTimeout(() => PrintWindow.close(), 1000);
        //         },
    },
};
</script>

<style></style>
